import { DataService } from './dataService'


export const SubCategoryService ={
    getSubCategory: async (data) => {
        return DataService.get('/admin/sub-category/list', data)
    },
    addSubCategory: async (data) => {
        return DataService.post('admin/sub-category/create', data)
    },
    // getSingalCategory: async (data) => {
    //     return DataService.get('/admin/category/list', data)
    // },
	updateCategory: async (data) => {
        let url = '/admin/sub-category/update'
        let str = DataService.convertObjToQueryStr(data)
	    url = url+str;
        return DataService.put(url, data)
    },
	deleteCategory: async (data) => {
        return DataService.delete('admin/sub-category/delete?'+"id"+"="+data.id, data)
    },
}